import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";

const theme = getTheme();

const styles = mergeStyleSets({
  variantDetailsFormContainer: {},
  variantDetailContainer: {},
  variantDetailsLabel: {
    borderTop: `1px solid ${theme.palette.neutralLight}`,
    borderRight: `1px solid ${theme.palette.neutralLight}`,
    borderLeft: `1px solid ${theme.palette.neutralLight}`,
    borderRadius: "4px 4px 0 0",
    padding: "8px 12px 0 12px",
    height: "44px",
  },

  // Variant Details Table Styles
  variantDetailsTableContainer: {
    border: `1px solid ${theme.palette.neutralLight}`,
    borderRadius: "4px",
  },
  variantDetailsTableDisabled: {
    opacity: 0.5,
    pointerEvents: "none",
    filter: "grayscale(1)",
  },

  // Variant Details Flag Styles
  variantDetailsFlagPill: {
    margin: 2,
    backgroundColor: `${theme.palette.themeLighter} !important`,
  },
  variantDetailsFlagTagContent: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  variantDetailsFlagKey: {
    backgroundColor: `${theme.palette.themeLighterAlt} !important`,
    borderTopLeftRadius: 9999,
    borderBottomLeftRadius: 9999,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    padding: "0 5px",
    userSelect: "text",
  },
  variantDetailsFlagValue: {
    userSelect: "text",
  },
  variantDetailPanelFeatureFlagContainer: {
    paddingTop: "12px",
  },

  //   Variant Detail panel
  variantDetailPanelFeatureFlagAstrict: {
    color: theme.palette.redDark,
    paddingRight: "4px",
  },
  variantDetailPanelFeatureFlagFormContainer: {
    padding: "12px",
    border: `1px solid ${theme.palette.neutralLight}`,
    borderRadius: "4px",
  },
  variantDetailPanelFeatureFlagsPreviewContainer: {
    backgroundColor: theme.palette.neutralLighterAlt,
    padding: "10px",
    width: "100%",
  },
  variantDetailPanelFooter: {
    width: "100%",
    padding: "12px",
  },
});

export { styles, theme };
